export default "__VITE_ASSET__D0eW7t2o__"